import {jsonArrayMember, jsonObject} from "typedjson";
import {DxListToolbarButton} from "./dx-list-toolbar-button";

/** Опции панели инструментов списка. */
@jsonObject
export class DxListToolbarOptions {
  @jsonArrayMember(DxListToolbarButton, {name: "buttons", emitDefaultValue: false, isRequired: false })
  private _buttons: DxListToolbarButton[] = [];

  get buttons(): DxListToolbarButton[] {
    return this._buttons;
  }

  set buttons(value: DxListToolbarButton[]) {
    this._buttons = value;
  }
}
